import * as Sentry from "@sentry/react";

export const initSentry = () =>
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // WARNING - disabled browser tracing, but this can be enabled for perf tracking
    integrations: [],
    beforeSend(event) {
      // Strip everything except stacktrace, user.email, request.url, tags, and server_name
      event.user = event.user?.email ? { email: event.user.email } : undefined;
      event.request = event.request?.url
        ? { url: event.request.url }
        : undefined;
      event.contexts = undefined;
      event.extra = undefined;
      event.breadcrumbs = undefined;
      event.modules = undefined;
      return event;
    },
  });

export const sentryErrorReporter = (_: any) => (next: any) => (action: any) => {
  try {
    next(action);
  } catch (err) {
    Sentry.captureException(err);
  }
};
